var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "divBox",
      class: { "inventory-adjust-embedded": _vm.embedded },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: _vm.embedded ? "never" : "always" },
        },
        [
          !_vm.embedded
            ? _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "div",
                    { staticClass: "page-header-bar" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-back" },
                          on: { click: _vm.goBack },
                        },
                        [_vm._v("返回")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "page-title" }, [
                        _vm._v("库存调整"),
                      ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate",
              attrs: { model: _vm.formValidate, "label-width": "120px" },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-form-item", { attrs: { label: "商品名称：" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.formValidate.productName)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c("el-tag", [
                              _vm._v(
                                _vm._s(
                                  _vm.formValidate.specMode
                                    ? "多规格"
                                    : "单规格"
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品封面图：", prop: "image" } },
                        [
                          _c("div", { staticClass: "upLoadPicBox" }, [
                            _vm.formValidate.image
                              ? _c("div", { staticClass: "pictrue" }, [
                                  _c("img", {
                                    attrs: { src: _vm.formValidate.image },
                                  }),
                                ])
                              : _c("div", { staticClass: "upLoad" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-camera cameraIconfont",
                                  }),
                                ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.specCombinations.length > 0
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "规格详情：" } },
                            _vm._l(
                              _vm.specCombinations,
                              function (spec, index) {
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("div", [_vm._v(_vm._s(spec.specName))]),
                                    _vm._v(" "),
                                    _vm._l(
                                      spec.specValues,
                                      function (item, index2) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: index2,
                                            staticClass: "mr10 mb5",
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(item) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                  ],
                                  2
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "库存调整：" } },
                        [
                          _c(
                            "div",
                            { staticClass: "mb10" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.batchAdjust("add")
                                    },
                                  },
                                },
                                [_vm._v("批量增加")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.batchAdjust("sub")
                                    },
                                  },
                                },
                                [_vm._v("批量减少")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.resetAdjust },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              ref: "stockTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                border: true,
                                data: _vm.stockData,
                                border: "",
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              }),
                              _vm._v(" "),
                              _vm.formValidate.specMode
                                ? _vm._l(
                                    _vm.specColumns,
                                    function (attr, index) {
                                      return _c("el-table-column", {
                                        key: index,
                                        attrs: {
                                          label: attr.label,
                                          prop: attr.prop,
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        scope.row[attr.prop]
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      })
                                    }
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "价格",
                                  prop: "price",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.price) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "原价",
                                  prop: "marketPrice",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.marketPrice) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "成本价",
                                  prop: "cost",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.cost) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "当前库存",
                                  prop: "stock",
                                  width: "120",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.stock) +
                                            "\n                "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "操作类型", width: "190" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-radio-group",
                                          {
                                            on: {
                                              change: function ($event) {
                                                return _vm.handleOperationChange(
                                                  scope.row
                                                )
                                              },
                                            },
                                            model: {
                                              value: scope.row.operationType,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "operationType",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row.operationType",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "add" } },
                                              [_vm._v("增加")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "sub" } },
                                              [_vm._v("减少")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "调整数量", width: "150" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            min: 0,
                                            max: _vm.getMaxAdjustValue(
                                              scope.row
                                            ),
                                            "controls-position": "right",
                                            size: "mini",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleAdjustValueChange(
                                                scope.row
                                              )
                                            },
                                          },
                                          model: {
                                            value: scope.row.adjustValue,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "adjustValue",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.adjustValue",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { label: "调整后库存", width: "120" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "warning-text":
                                                _vm.getFinalStock(scope.row) <
                                                0,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.getFinalStock(scope.row)
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.embedded
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "调整备注：" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 3,
                                  placeholder: "请输入调整原因或备注",
                                },
                                model: {
                                  value: _vm.adjustRemark,
                                  callback: function ($$v) {
                                    _vm.adjustRemark = $$v
                                  },
                                  expression: "adjustRemark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.embedded
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    disabled:
                                      _vm.hasNegativeStock ||
                                      !_vm.hasAnyAdjustment,
                                  },
                                  on: { click: _vm.submitAdjust },
                                },
                                [
                                  _vm._v(
                                    "\n              提交调整\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.hasNegativeStock
                                ? _c(
                                    "span",
                                    { staticClass: "warning-text ml10" },
                                    [
                                      _vm._v(
                                        "\n              * 存在调整后库存为负数的情况，请修改\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.hasAnyAdjustment
                                ? _c(
                                    "span",
                                    { staticClass: "info-text ml10" },
                                    [
                                      _vm._v(
                                        "\n              * 请至少调整一个规格的库存\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.embedded
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _vm.hasNegativeStock
                          ? _c("span", { staticClass: "warning-text" }, [
                              _vm._v(
                                "\n            * 存在调整后库存为负数的情况，请修改\n          "
                              ),
                            ])
                          : !_vm.hasAnyAdjustment
                          ? _c("span", { staticClass: "info-text" }, [
                              _vm._v(
                                "\n            * 请至少调整一个规格的库存\n          "
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.batchDialog.title,
            visible: _vm.batchDialog.visible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.batchDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "操作类型：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.batchDialog.operationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.batchDialog, "operationType", $$v)
                        },
                        expression: "batchDialog.operationType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "add" } }, [
                        _vm._v("增加"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "sub" } }, [
                        _vm._v("减少"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "调整数量：" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "100%" },
                    attrs: { min: 0, "controls-position": "right" },
                    on: { change: _vm.handleBatchValueChange },
                    model: {
                      value: _vm.batchDialog.adjustValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.batchDialog, "adjustValue", $$v)
                      },
                      expression: "batchDialog.adjustValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "将影响以下规格：" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: true,
                        data: _vm.batchDialog.selectedItems,
                        border: "",
                        "max-height": "300",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _vm.formValidate.specMode
                        ? _c("el-table-column", {
                            attrs: { label: "规格值", prop: "sku" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.sku) +
                                          "\n            "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4263742320
                            ),
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "当前库存",
                          prop: "stock",
                          width: "120",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.stock) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "调整数量", width: "120" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.batchDialog.adjustValue) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "调整后库存", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    class: {
                                      "warning-text":
                                        _vm.calculateFinalStock(scope.row) < 0,
                                      "success-text":
                                        _vm.calculateFinalStock(scope.row) >= 0,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.calculateFinalStock(scope.row)
                                        ) +
                                        "\n                "
                                    ),
                                    _vm.calculateFinalStock(scope.row) < 0
                                      ? _c("i", {
                                          staticClass: "el-icon-warning",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.batchHasNegative
                    ? _c("div", { staticClass: "error-tip mt10" }, [
                        _c("i", { staticClass: "el-icon-warning" }),
                        _vm._v(
                          " 调整后将导致部分规格库存为负数，请修改调整数量！\n        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchDialog.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled:
                      _vm.batchHasNegative || _vm.batchDialog.adjustValue === 0,
                  },
                  on: { click: _vm.confirmBatchAdjust },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }